<template>
  <div class="timeline-event" />
</template>

<script>
export default {
  name: 'TimelineEvent',
};
</script>

<style lang="scss">
  @import '@/styles/variables.scss';
  @import '@/styles/functions.scss';

  .timeline-event {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background-color: $mediumWhite;
    position: relative;

    &:after {
      content: '';
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background-color: $damiGrass;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }

    @include media-breakpoint-up(md) {
      width: 46px;
      height: 46px;

      &:after {
        width: 12px;
        height: 12px;
      }
    }
  }
</style>
